import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  CardContent,
  Grid,
  Typography,
  makeStyles,
  colors,
  Hidden
} from '@material-ui/core';
import { FaArrowDown } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { formatAmount } from 'src/utils/helperFunctions';

const useStyles = makeStyles(theme => ({
  root: { borderRight: '1px dashed #f4f4f5', cursor: 'pointer' },
  avatar: {
    backgroundColor: '#f4f6f8',
    height: 35,
    width: 35,
    cursor: 'pointer'
  },
  mainBox: {
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center'
  },
  differenceIcon: {
    color: colors.orange[900]
  },
  differenceValue: {
    color: '#545454b8',
    marginRight: theme.spacing(1)
  }
}));

const Payouts = ({ payout, className, ...rest }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  return (
    <CardContent
      className={clsx(classes.root, className)}
      {...rest}
      onClick={() => navigate('/app/payouts', { replace: false })}
    >
      <Grid
        className={classes.mainBox}
        container
        justify="space-between"
        spacing={3}
      >
        <Grid item>
          <Typography
            color="textPrimary"
            style={{
              fontWeight: '500',
              display: 'flex',
              alignItems: 'center',
              marginBottom: '0.5rem'
            }}
            gutterBottom
            variant="h5"
          >
            Payouts
            <FaArrowDown style={{ marginLeft: '5px', color: '#d07bd5' }} />
          </Typography>
          <Hidden lgUp>
            <Typography color="textPrimary" variant="h2">
              {payout >= 0 && formatAmount(payout)}
              <span style={{ fontSize: 18, fontWeight: 700 }}> FCFA</span>
            </Typography>
          </Hidden>
          <Hidden mdDown>
            <Typography color="textPrimary" variant="h1">
              {payout >= 0 && formatAmount(payout)}
              <span style={{ fontSize: 18, fontWeight: 700 }}> FCFA</span>
            </Typography>
          </Hidden>
        </Grid>
      </Grid>
    </CardContent>
  );
};

Payouts.propTypes = {
  className: PropTypes.string
};

export default Payouts;
